module.exports = __webpack_public_path__ + "static/2020-in-review-featured-6f3a47fcc1f0a1bc3c1e80a3c0e9ab13.png";